import * as types from '../../../../types/masters/metalPurity/metalColor/metalColorTypes';
import * as api from '../../../../../api/masters/metalPurity/metalColor/metalColorApi';

export const fetchMetalColors = () => async (dispatch) => {
  dispatch({ type: types.FETCH_METAL_COLOR_REQUEST });
  try {
    const data = await api.fetchMetalColors();
    dispatch({ type: types.FETCH_METAL_COLOR_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: types.FETCH_METAL_COLOR_FAILURE, payload: error.message });
  }
};

export const addMetalColor = (metalColor) => async (dispatch) => {
  try {
    const res = await api.addMetalColor(metalColor);
    dispatch({ type: types.ADD_METAL_COLOR_SUCCESS, payload: res });
    dispatch(fetchMetalColors());
  } catch (error) {
    dispatch({ type: types.METAL_COLOR_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const updateMetalColor = (id, metalColor) => async (dispatch) => {
  try {
    console.log('Updating metal color with ID:', id, 'Data:', metalColor);
    const res = await api.updateMetalColor(id, metalColor);
    console.log('Update response:', res);
    dispatch({ type: types.UPDATE_METAL_COLOR_SUCCESS, payload: res });
    dispatch(fetchMetalColors());
  } catch (error) {
    console.error('Update error:', error);
    dispatch({ type: types.METAL_COLOR_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const deleteMetalColor = (id) => async (dispatch) => {
  try {
    await api.deleteMetalColor(id);
    dispatch({ type: types.DELETE_METAL_COLOR_SUCCESS, payload: id });
    dispatch(fetchMetalColors());
  } catch (error) {
    dispatch({ type: types.METAL_COLOR_FORM_ERROR, payload: error.response?.data?.message || error.message });
  }
};

export const setMetalColorEdit = (metalColor) => ({
  type: types.SET_METAL_COLOR_EDIT,
  payload: metalColor,
});

export const clearMetalColorEdit = () => ({
  type: types.CLEAR_METAL_COLOR_EDIT,
}); 